// Footer "Restons en contact" : toast de confirmation apres l'inscription (formulaire de contact natif,
// voir assets/contact-form-ajax.js, charge AVANT ce fichier). L'envoi vers Brevo est dans assets/brevo-signup.js.
(function () {
  var form = document.getElementById('FooterNewsletter');
  if (!form || !window.HexagonContactForm) return;
  window.HexagonContactForm.init(form, {
    successTitle: 'Merci, votre inscription est bien enregistrée.',
    successText: 'Vous recevrez les actualités Hexagon Padel.'
  });
})();
